<template>
    <div v-if="session">
        <top-navbar padding="6" :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="row">
                <div class="col-11">
                    <session-header :session="session" :status-data="statusData" :status-colors="statusColors"></session-header>
                    <session-steps :session="session" current="evaluation"></session-steps>
                </div>
                <div class="col-1">
                </div>
            </div>
            <session-evaluation v-if="evaluation"
                :session="session"
                :grid="grid"
                :competencies="competencies"
                :stats="stats"
                :evaluation="evaluation"
                @reload-session="loadSession"
                @reload-stats="loadStats"
                ></session-evaluation>
        </div>
    </div>
</template>

<script>
    import SessionFeatures from './sessions/SessionFeatures'
    import SessionHeader from './sessions/SessionHeader';
    import SessionSteps from './sessions/SessionSteps';
    import SessionEvaluation from './sessions/SessionEvaluation';

    export default {

        components: {
            SessionHeader, SessionSteps, SessionEvaluation
        },

        data() {
            return {
                statusData: [],
                statusColors: {},
                session: null,
                grid: null,
                competencies: null,
                stats: null,
                evaluation: null,
                features: new SessionFeatures(this.$router, this.$auth),
                reloaderId: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.sessions'),
                        route: '/socrates/ui/dashboard/sessions'
                    },
                    {
                        name: this.session.cohort.name + ' / ' + this.session.degree.name,
                        route: '/socrates/ui/dashboard/sessions/registrations/' + this.session.registration_id
                    },
                    {
                        name: this.session.learner.name,
                    },
                ]
            },

            canStartReloader() {
                return !this.session.sync && this.features.ownSession(this.session) && (this.session.status != 'closed' && this.session.status != 'archived')
            },
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/socrates/api/front/dashboard/page/sessions/' + to.params.id + '/evaluation', { params: {
                include: ['grid', 'competencies', 'status_data', 'status_colors', 'rights']
            }})
            .then(resp => {
                next(vm => {
                    vm.session = resp.data.data
                    vm.grid = resp.data.included.grid
                    vm.competencies = resp.data.included.competencies
                    vm.statusData = resp.data.included.status_data
                    vm.statusColors = resp.data.included.status_colors
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.loadContent()
                    vm.loadStats()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                } else if (err.response.status == 444) {
                    // This may happen if the connection fails with an online session.
                    next({ name: 'home' });
                }
            });
        },

        beforeDestroy() {
            this.clearReloader()
        },

        methods: {

            clearReloader() {
                if (this.reloaderId) {
                    clearInterval(this.reloaderId)
                }
            },

            initReloader() {
                if (!this.reloaderId && this.canStartReloader) {
                    this.reloaderId = setInterval(() => { this.loadSession() }, 3000)
                }
                if (this.reloaderId && !this.canStartReloader) {
                    clearInterval(this.reloaderId)
                    this.reloaderId = null
                }
            },

            loadSession() {
                axios.get('/socrates/api/front/dashboard/page/sessions/' + this.session.id + '/evaluation')
                .then(resp => {
                    this.session = resp.data.data

                    if (this.features.redirectOwnerIfSessionChanged(this.session)) {
                        return
                    }

                    this.loadStats()
                })
                .catch(err => {
                    if (err.response.status == 500) {
                        // Do nothing. This may happen occasionally.
                    } else if (err.response.status == 403) {
                        // The session may have been reset. Go back to the configuration page.
                        this.features.openConfiguration(this.session)
                    } else if (err.response.status == 444) {
                        // This may happen if the connection fails with an online session.
                        this.$router.push({ name: 'home'})
                    } else {
                        this.$auth.handleErrorVm(err, this)
                    }
                })        
            },

            loadStats() {
                axios.get('/socrates/api/front/dashboard/data/sessions/' + this.session.id + '/evaluation/stats')
                .then(resp => {
                    this.stats = resp.data.data
                    this.initReloader()
                })
            },

            loadContent() {
                axios.get('/socrates/api/front/dashboard/data/sessions/' + this.session.id + '/evaluation/content')
                .then(resp => {
                    this.evaluation = resp.data.data
                    this.$loader.hide()
                })
            },
        }
    }
</script>
